// import { fetchCertificate } from 'features/Certificate'
// import { GetServerSideProps } from 'next'

// import { createQueryClient, dehydrateState } from 'config/query'

export { CertificatePage as default } from 'features/Certificate'

// export const getServerSideProps: GetServerSideProps = async ({ params }) => {
//   const queryClient = createQueryClient()
//   const cuid = typeof params?.cuid === 'string' ? params?.cuid : ''

//   await queryClient.prefetchQuery(['certificate', { cuid }], () =>
//     fetchCertificate(cuid)
//   )

//   return { props: { ...dehydrateState(queryClient) } }
// }
